import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import BMILogo from "../../assets/images/BMIlogo.png";
import { useAuth } from "../../routing/AuthProvider";
const theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontFamily: "Poppins, Arial, sans-serif",
        },
      },
    },
  },
});

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const isLoggedIn = localStorage.getItem("site") !== null;

  const userData = localStorage.getItem("userName");
  const auth = useAuth();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
    handleMenuClose();
  };

  const handleLogoutConfirm = () => {
    auth.logOut();
    setOpenLogoutDialog(false);
  };

  const handleLogoutCancel = () => {
    setOpenLogoutDialog(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">
            <img
              src={BMILogo}
              alt="BMI"
              style={{ height: "80px", marginRight: "10px" }}
            />
          </Typography>
          <Typography
            variant="h6"
            style={{
              flexGrow: 1,
              textAlign: "right",
              fontFamily: "Poppins, Arial, sans-serif",
            }}
          >
            BMI Connect
          </Typography>
          <Typography
            variant="h10"
            style={{
              flexGrow: 1,
              textAlign: "right",
              fontFamily: "Poppins, Arial, sans-serif",
            }}
          >
            {isLoggedIn ? (
              <Button color="inherit" onClick={handleLogoutClick}>
                {userData} - Logout
              </Button>
            ) : null}
          </Typography>
        </Toolbar>
        {/*isLoggedIn && (
          <Box
            sx={{
              bgcolor: "primary.main",
              color: "primary.contrastText",
              py: 1,
              px: 2,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography
              variant="body1"
              style={{
                fontFamily: "Poppins, Arial, sans-serif",
                marginRight: "20px",
              }}
            ></Typography>
          </Box>
        ) */}
      </AppBar>

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={openLogoutDialog}
        onClose={handleLogoutCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleLogoutConfirm} color="primary" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default Header;
